import { useState } from "react";
import styled from "styled-components";
import * as XLSX from "xlsx";
import GreenButton from "../../../../ui/GreenButton.js";


const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  padding: 16px;
`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: #575757;
  background-color: transparent;
  transition: transform 0.1s;
  font-size: medium;
  font-weight: bold;
  &:hover {
    transform: scale(1.1);
  }
`;

const Div3 = styled.div`
  width: 80vw;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Div4 = styled.div`

  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 16px 24px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;



  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

    button {
      align-self: stretch;
      margin-top: 12px;
    }
  }
`;
const H2 = styled.h2`
  font-size: 18px;
  color: #575757;
  margin: 0 0 8px 0;
`;


const ServicosLista = styled.div`
  background-color: #f5f5f5;
  margin: 0px 0 20px 0;
  padding: 15px;
  border-radius: 0px 0px 8px 8px;
`;

const ServicoItem = styled.div`
  padding: 10px;
  border-bottom: 1px solid #ddd;

  &:last-child {
    border-bottom: none;
  }

  p {
    margin: 4px 0;
    font-size: 16px;
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Container2 = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column; // <- força em coluna no mobile
  }
`;



const ServicosWrapper = styled.div`
  max-height: ${({ expandido }) => (expandido ? '500px' : '0')};
  overflow-y: scroll;
  transition: max-height 0.5s ease;
`;
const Div7 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 250px;
  p{
    color: #575757;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

  }
`;
const CustosWrapper = styled.div`
  margin-top: 8px;
  margin-left: 20px;
  padding: 10px 15px;
  background-color: #f9f9f9;
  border-left: 4px solid #E0F0FF;
  border-radius: 6px;

  ul {
    margin: 0;
    padding: 0;
    list-style: inside;
  }

  li {
    margin-bottom: 4px;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 12px 16px;
  font-weight: bold;
  border-bottom: 2px solid #ccc;

  span {
    user-select: none;
  }
`;




const Grid = ({ listaCustoMes, listaCustoMesCusto, listaItemCustoMesCusto }) => {




  const [osExpandida, setOsExpandida] = useState(null);
  const [parcelaExpandida, setParcelaExpandida] = useState(null);


  //===========================================================================================Ordenar a tabela
  const [sortConfig, setSortConfig] = useState({ key: 'MES_REFERENCIA', direction: 'desc' });
  const sortedLista = [...listaCustoMes].sort((a, b) => {
    const { key, direction } = sortConfig;

    let aVal = a[key];
    let bVal = b[key];

    if (key === 'TOTAL_MES') {
      // ordenar como número
      aVal = Number(aVal);
      bVal = Number(bVal);
    } else if (key === 'MES_REFERENCIA') {
      // transformar "MM/YYYY" em Date para comparar corretamente
      const [mesA, anoA] = aVal.split('/').map(Number);
      const [mesB, anoB] = bVal.split('/').map(Number);
      aVal = new Date(anoA, mesA - 1);
      bVal = new Date(anoB, mesB - 1);
    }

    if (aVal < bVal) return direction === 'asc' ? -1 : 1;
    if (aVal > bVal) return direction === 'asc' ? 1 : -1;
    return 0;
  });


  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };



  //===========================================================================================Exportar Excel




  const exportarParaExcel = () => {
    const linhas = [];

    sortedLista.forEach((mes) => {
      // Cabeçalho do mês
      linhas.push([`📅 Mês: ${mes.MES_REFERENCIA}`]);
      linhas.push([`💰 Total do Mês:`, Number(mes.TOTAL_MES)]);
      linhas.push([]); // linha em branco

      // Lista de objetos de custo para o mês
      const objetoCustoMes = listaCustoMesCusto.filter(
        (p) => p.MES_REFERENCIA === mes.MES_REFERENCIA
      );

      objetoCustoMes.forEach((servico) => {
        linhas.push([
          `🧾 ${servico.COD_OBJETOCUSTO} - ${servico.DESC_OBJETOCUSTO}`,
          `Total Setor`,
          Number(servico.TOTAL_POR_SETOR)
        ]);

        // Lista de contratos daquele objeto de custo
        const objetosCusto = listaItemCustoMesCusto.filter(
          (obj) =>
            obj.MES_REFERENCIA === mes.MES_REFERENCIA &&
            obj.COD_OBJETOCUSTO === servico.COD_OBJETOCUSTO
        );

        objetosCusto.forEach((obj) => {
          const qtde = Number(obj.QTDE) || 0;
          const vlrUnit = Number(obj.VLRUNITARIO) || 0;
          const totalContrato = Number(obj.TOTAL_OBJETO_CONTRATO) || 0;

          linhas.push([
            `   • ${obj.NUMEROCONTRATO} - ${obj.DESCRICAORESUMIDA}`,
            `${qtde} x ${vlrUnit.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}`,
            totalContrato
          ]);
        });


        linhas.push([]); // espaço entre setores
      });

      linhas.push([]); // espaço entre meses
    });

    // Gera e salva o arquivo Excel
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(linhas);
    XLSX.utils.book_append_sheet(wb, ws, "Custos por Mês");
    XLSX.writeFile(wb, "central_ti_custos_por_mes.xlsx");
  };





  return (



    <Container>

      <GreenButton onClick={exportarParaExcel}>Exportar Excel</GreenButton>

      <Div3>

        <HeaderRow>
          <span onClick={() => handleSort("MES_REFERENCIA")} style={{ cursor: 'pointer', flex: 1 }}>
            📅 Mês Referência {sortConfig.key === 'MES_REFERENCIA' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
          </span>

          <span onClick={() => handleSort("TOTAL_MES")} style={{ cursor: 'pointer', flex: 1, textAlign: 'right' }}>
            💰 Total Mensal {sortConfig.key === 'TOTAL_MES' ? (sortConfig.direction === 'asc' ? '↑' : '↓') : ''}
          </span>

          <span style={{ flex: 0.5, textAlign: 'right' }}>
            🔍 Ações
          </span>
        </HeaderRow>


        {sortedLista.map((item, i) => {
          const objetoCustoMes = listaCustoMesCusto.filter(
            (p) => p.MES_REFERENCIA === item.MES_REFERENCIA
          );


          return (
            <div key={i}>
              <Div4>


                <H2>Mês: {item.MES_REFERENCIA}</H2>

                <Div7>
                  <p>
                    <strong>Total:</strong>{" "}
                    {item.TOTAL_MES.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })
                    }
                  </p>
                  <Button onClick={() =>
                    setOsExpandida(prev => prev === item.MES_REFERENCIA ? null : item.MES_REFERENCIA)
                  }>
                    {osExpandida === item.MES_REFERENCIA ? 'Ocultar...' : 'Ver dados...'}
                  </Button>
                </Div7>




              </Div4>

              <ServicosWrapper expandido={osExpandida === item.MES_REFERENCIA}>
                <ServicosLista>
                  {objetoCustoMes.length === 0 ? (
                    <p>Nenhuma informação encontrada.</p>
                  ) : (

                    objetoCustoMes.map((servico, idx) => {
                      const chaveParcela = `${servico.MES_REFERENCIA}-${servico.COD_OBJETOCUSTO}`;

                      const objetosCusto = listaItemCustoMesCusto.filter(
                        (obj) =>
                          obj.MES_REFERENCIA === item.MES_REFERENCIA &&
                          obj.COD_OBJETOCUSTO === servico.COD_OBJETOCUSTO
                      );

                      return (
                        <ServicoItem key={idx}>
                          <Container2>
                            <span>
                              {servico.COD_OBJETOCUSTO} - {servico.DESC_OBJETOCUSTO}

                            </span>

                            <Div7>
                              <span>
                                {Number(servico.TOTAL_POR_SETOR).toLocaleString("pt-BR", {
                                  style: "currency",
                                  currency: "BRL",
                                })}
                              </span>

                              <Button
                                onClick={() =>
                                  setParcelaExpandida((prev) =>
                                    prev === chaveParcela ? null : chaveParcela
                                  )
                                }
                              >
                                {parcelaExpandida === chaveParcela ? "Ocultar gastos" : "Ver gastos"}
                              </Button>
                            </Div7>
                          </Container2>
                          {parcelaExpandida === chaveParcela && (
                            <CustosWrapper>
                              {objetosCusto.length === 0 ? (
                                <p>Nenhuma informação de custo.</p>
                              ) : (
                                <ul>
                                  {objetosCusto.map((obj, i) => (
                                    <li key={i} style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
                                      <span>
                                        <strong>{obj.NUMEROCONTRATO}-{obj.DESCRICAORESUMIDA}</strong>:
                                      </span>
                                      <span>
                                        {Number(obj.TOTAL_OBJETO_CONTRATO).toLocaleString("pt-BR", {
                                          style: "currency",
                                          currency: "BRL",
                                        })}
                                      </span>
                                    </li>

                                  ))}
                                </ul>
                              )}
                            </CustosWrapper>
                          )}

                        </ServicoItem>
                      );
                    })


                  )}
                </ServicosLista>
              </ServicosWrapper>


            </div>
          );
        })}

      </Div3>


    </Container>

  );
};


export default Grid;
